module.exports = __webpack_public_path__ + "static/media/s1.7ae11b41.png";